import AOS from 'aos';

'use strict';
const aos = {
	init: function() {
		setTimeout(() => {
			AOS.init({
				once: true,
				offset: 0,
				duration: 600,
			});
		}, 100);
	},
};

export default aos;